// extracted by mini-css-extract-plugin
export default {"nftSellOfferListCreateButton":"ttIlJr7HUW0BI5W1sbdU"};